export default "__VITE_ASSET__b8iTLsYQ__"